import { useEffect, useState } from "react";

export function useBrand() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);

  useEffect(() => {
    const controller = new AbortController();
    const fetchItems = async () => {
      try {
        setLoading(true);
        setError(null);
        const url = new URL(`${process.env.REACT_APP_SERVER_PATH}/brand`);
        if (searchTerm && searchTerm.trim().length > 0) {
          url.searchParams.append("keyword", searchTerm.trim());
        }
        url.searchParams.append("page", String(page));
        const response = await fetch(url.toString(), {
          signal: controller.signal,
        });
        if (!response.ok) throw new Error("Failed to fetch brands");
        const data = await response.json();
        setItems(Array.isArray(data) ? data : []);
      } catch (err) {
        if (err.name !== "AbortError") {
          setError(err.message || "Unknown error");
        }
      } finally {
        setLoading(false);
      }
    };
    fetchItems();
    return () => controller.abort();
  }, [searchTerm, page]);

  return {
    items,
    loading,
    error,
    searchTerm,
    setSearchTerm,
    page,
    setPage,
  };
}
